import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import Icon from '~/components/Icon';
import * as S from './styles';

class FoldedMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleClickOutside = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { isOpen } = this.state;
    const { label, options, invert } = this.props;

    return (
      <S.HeaderGroup isOpen={isOpen}>
        <S.FoldedMenuTrigger onClick={() => this.setState({ isOpen: true })}>
          {label}
          <Icon
            name={isOpen ? 'chevronUp' : 'chevronDown'}
            size={10}
            color="black"
          />
        </S.FoldedMenuTrigger>
        <S.FoldedMenu invert={invert}>
          {options.map(opt => {
            return (
              <S.FoldedMenuOption
                key={opt.label}
                onClick={() => {
                  opt.action();
                  this.setState({
                    isOpen: false,
                  });
                }}
              >
                {opt.label}
              </S.FoldedMenuOption>
            );
          })}
        </S.FoldedMenu>
      </S.HeaderGroup>
    );
  }
}

FoldedMenu.propTypes = {
  options: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  invert: PropTypes.bool,
};

FoldedMenu.defaultProps = {
  options: [],
  label: '',
  invert: false,
};

export default onClickOutside(FoldedMenu);
